var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{staticClass:"time-setup__form caption",attrs:{"fields":_vm.fields},model:{value:(_vm.formValues),callback:function ($$v) {_vm.formValues=$$v},expression:"formValues"}})}
var staticRenderFns = []

export { render, staticRenderFns }